export const shuffleArray = array => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

export const generateCode = () => {
  let alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  return Array(4).fill(null).map(() => alphabet.charAt(Math.floor(Math.random() * 26))).join('')
}